import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { ConversionBanner } from "@/components/site/ConversionBanner";
import { Services } from "@/components/site/Services";
import { Differentials } from "@/components/site/Differentials";
import { SeoAreas } from "@/components/site/SeoAreas";
import { Gallery } from "@/components/site/Gallery";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Testimonials } from "@/components/site/Testimonials";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

function App() {
  useLenis();

  return (
    <div className="App grain-overlay relative min-h-screen bg-[#111111]">
      <Navbar />
      <main>
        <Hero />
        <ConversionBanner />
        <Services />
        <Differentials />
        <SeoAreas />
        <Gallery />
        <HowItWorks />
        <Testimonials />
        <FinalCta />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
